import * as CONST from '../ActionTypes';

const initialState = {
  agencyList: [],
};

function agency(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 支店一覧取得
    // -----------------
    case CONST.GET_AGENCY_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          agencyList: action.payload,
        },
      );
    case CONST.GET_AGENCY_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          agencyList: [],
        },
      );
    default:
      return state;
  }
}

export default agency;
